<template>
    <div>
        <div v-if="loading" class="loader-container">
            <div class="loader"></div>
        </div>
        <div class="row">
            <div class="col-md-24">
                <card>
                    <template slot="header">
                        <h5 class="card-category"></h5>
                        <h3 class="card-title">Kontrole ({{ totalRecords }})</h3>
                    </template>

                    <!-- FILTERI -->
                    <div class="row">
                        <div class="col-md-3">
                            <h4 slot="header" class="card-title">Početak</h4>
                            <base-input>
                                <el-date-picker type="datetime" placeholder="Početak" value-format="timestamp"
                                    format="dd.MM.yyyy. HH:mm:ss" v-model="filter.startStamp">
                                </el-date-picker>
                            </base-input>
                        </div>
                        <div class="col-md-3">
                            <h4 slot="header" class="card-title">Kraj</h4>
                            <base-input>
                                <el-date-picker type="datetime" placeholder="Kraj" value-format="timestamp"
                                    format="dd.MM.yyyy. HH:mm:ss" v-model="filter.endStamp">
                                </el-date-picker>
                            </base-input>
                        </div>
                        <div class="col-md-3">
                            <h4 slot="header" class="card-title">Tablice</h4>
                            <base-input type="text" v-model="filter.plates" placeholder="Tablice">
                            </base-input>
                        </div>
                        <!-- <div class="col-md-3">
                            <h4 slot="header" class="card-title">Lokacija</h4>
                            <base-input>
                                <el-select v-model="filter.parkingId" class="select-primary" name="parking" clearable>
                                    <el-option v-for="p in parkings" class="select-primary" :label="p.name" :value="p.id"
                                        :key="p.id"></el-option>
                                </el-select>
                            </base-input>
                        </div> -->
                    </div>

                    <div class="row">
                        <div class="col-md-3">
                            <h4 slot="header" class="card-title">Kontrolor</h4>
                            <base-input>
                                <el-select v-model="filter.employeeId" class="select-primary" name="employee" clearable>
                                    <el-option v-for="emp in employees" class="select-primary"
                                        :style="emp.active ? 'color: green;' : 'color:red'"
                                        :label="emp.active ? emp.name + ' ' + emp.lastName + ' AKTIVAN' : emp.name + ' ' + emp.lastName + ' NEAKTIVAN'"
                                        :value="emp.id" :key="emp.id"></el-option>
                                </el-select>
                            </base-input>
                        </div>
                        <div class="col-md-3">
                            <h4 slot="header" class="card-title">Tip kontrole</h4>
                            <base-input>
                                <el-select v-model="filter.commentFilter" class="select-primary" name="commentFilter">
                                    <el-option label="Sve" value="all"></el-option>
                                    <el-option label="Akademska karta" value="Akademska karta"></el-option>
                                    <el-option label="Doplatna karta" value="Doplatna karta"></el-option>
                                    <el-option label="Provera tablica" value="Provera tablica"></el-option>
                                </el-select>
                            </base-input>
                        </div>
                        <div class="col-md-3">
                            <base-input label="Broj redova" style="margin-top: 15px;">
                                <el-select v-model="max" class="select-primary" name="rows" style="width: 200px;">
                                    <el-option v-for="r in rows" class="select-primary" :label="r.name" :value="r.value"
                                        :key="r.value"></el-option>
                                </el-select>
                            </base-input>
                        </div>
                        <div class="col-md-3">
                            <h4 slot="header" class="card-title">&nbsp;</h4>
                            <base-button class="mt-3" native-type="submit" type="primary"
                                @click="getControlls()">Pretraži</base-button>
                        </div>
                    </div>

                    <!-- TABELA -->
                    <el-table :data="controlls" v-loading="tableLoading" @sort-change="handleSort"
                        :default-sort="{ prop: sortField, order: sortOrder }">

                        <el-table-column min-width="140" prop="stamp" label="Datum" sortable="custom">
                            <template slot-scope="scope">
                                <span>{{ formatDate(scope.row.stamp) }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column min-width="100" prop="plates" label="Tablice" sortable="custom">
                            <template slot-scope="scope">
                                <span>{{ scope.row.plates }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column min-width="150" prop="parking" label="Lokacija">
                            <template slot-scope="scope">
                                <span>{{ scope.row.parking?.name }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column min-width="100" prop="employee" label="Kontrolor">
                            <template slot-scope="scope">
                                <span v-if="scope.row.employee">{{ scope.row.employee.name }} {{
                                    scope.row.employee.lastName }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column min-width="120" prop="comment" label="Tip kontrole" sortable="custom">
                            <template slot-scope="scope">
                                <span>{{ scope.row.comment }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column min-width="200" prop="checkPlatesMessage" label="Poruka">
                            <template slot-scope="scope">
                                <span v-if="scope.row.checkPlatesMessage">{{ scope.row.checkPlatesMessage }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column min-width="80" prop="ticketId" label="Kazna">
                            <template slot-scope="scope">
                                <span v-if="scope.row.ticketId" style="color: red;">DA</span>
                                <span v-else style="color: green;">NE</span>
                            </template>
                        </el-table-column>

                    </el-table>

                    <!-- PAGINACIJA -->
                    <div class="block">
                        <span class="demonstration" style="color: white;">Ukupno stranica: {{ totalPages }}</span><br>
                        <base-pagination class="pagination-no-border" v-model="page" :per-page="max"
                            :total="totalRecords" @input="changePage">
                        </base-pagination>
                    </div>
                </card>
            </div>
        </div>
    </div>
</template>

<script>
import { TabPane, Tabs, BasePagination } from 'src/components';
import { Table, TableColumn, DatePicker, Select, Option } from 'element-ui';
import axios from '@/util/axiosinstance';

const rows = [
    { value: 10, name: "10" },
    { value: 20, name: "20" },
    { value: 50, name: "50" },
    { value: 100, name: "100" },
    { value: 500, name: "500" }
];

export default {
    components: {
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [DatePicker.name]: DatePicker,
        [Option.name]: Option,
        [Select.name]: Select,
        TabPane,
        Tabs,
        BasePagination
    },
    mounted() {
        this.getParkings();
        this.getEmployees();
        this.getUserPageFilter();
    },
    data() {
        const now = new Date();
        const startStamp = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0).getTime();
        const endStamp = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59).getTime();

        return {
            rows,
            url: 'https://budva.scancar.org:8443/kuca',
            loading: false,
            tableLoading: false,
            controlls: [],
            filter: {
                startStamp: startStamp,
                endStamp: endStamp,
                plates: null,
                parkingId: null,
                employeeId: null,
                commentFilter: 'all'
            },
            employees: [],
            parkings: [],
            page: 1,
            max: 100,
            totalRecords: 0,
            totalPages: 0,
            sortField: "stamp",
            sortOrder: "descending"
        };
    },
    methods: {
        getUserPageFilter() {
            this.loading = true;

            axios.get(this.url + '/settings/getUserPageFilter?page=28').then(result => {
                this.loading = false;

                if (result.data.result === 'ok' && result.data.filter) {
                    this.filter = result.data.filter;
                }
                this.getControlls();
            });
        },
        formatDate(timestamp) {
            if (!timestamp) return '';
            return new Date(timestamp).toLocaleString("de-DE");
        },
        changePage(item) {
            this.page = item;
            this.getControlls();
        },
        handleSort({ prop, order }) {
            this.sortField = prop;
            this.sortOrder = order;
            this.getControlls();
        },
        getParkings() {
            axios.get(this.url + '/parking/getParkings').then(result => {
                if (result.data.result === 'ok') {
                    this.parkings = result.data.parkings;
                }
            });
        },
        getEmployees() {
            const body = { onlyActive: false };
            axios.post(this.url + '/employee/getEmployees', body).then(result => {
                if (result.data.result === 'ok') {
                    this.employees = result.data.employees;
                }
            });
        },
        getControlls() {
            this.tableLoading = true;

            const f = {
                ...this.filter,
                page: this.page,
                max: this.max,
                sortField: this.sortField,
                sortOrder: this.sortOrder,
                pageId: '28'
            };

            axios.post(this.url + '/ticket/getAllControlls', f).then(result => {
                this.tableLoading = false;

                if (result.data.result === 'ok') {
                    this.controlls = result.data.controlls;
                    this.totalPages = result.data.totalPages;
                    this.totalRecords = result.data.totalRecords;
                } else {
                    this.$notify({
                        message: result.data.reason,
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            });
        }
    }
};
</script>

<style lang="scss">
.loader-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-color: rgba(255, 255, 255, 0.7);
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 9999;
}

.loader {
    border: 8px solid #f3f3f3;
    border-top: 8px solid #3498db;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}
</style>